import React from 'react';

import { FileType } from '../../../types/common.types';

type Props = {
  className?: string;
  src: FileType | File | string | undefined;
  onClick?: () => void;
  controls?: boolean;
};

const Video = ({ className, src, onClick, controls }: Props) => {
  // TODO: Allow video to be played from URL
  if (!src) return null;

  return (
    <video className={className} controls={controls} onClick={onClick} data-testid="video">
      <source src={typeof src === 'string' ? src : URL.createObjectURL(src as Blob)} />
    </video>
  );
};

export default Video;
